import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { getChildrenToRender } from './utils';
import RczpDetail from './RczpDetail';

import { Collapse, Icon } from 'antd';
const { Panel } = Collapse;

var hangYeList = window.apiObj.zhaoPinList

const panelChildren = []
hangYeList.forEach((element,index) => {
  panelChildren.push( 
    <Panel header={element.title +' | '+ element.department} key={index+''} style={customPanelStyle}>
      <RczpDetail list={element.list} content={element.content} title={element.title} />
    </Panel>)
});

const customPanelStyle = {
  background: '#f4f4f4',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

class Content9 extends React.PureComponent {
  getBlockChildren = (block, i) => {
    const { isMobile } = this.props;
    const item = block.children;
    const textWrapper = (
      <QueueAnim
        key="text"
        leaveReverse
        delay={isMobile ? [0, 100] : 0}
        {...item.textWrapper}
      >
        <div key="time" {...item.time}>
          {item.time.children}
        </div>
        <h2 key="title" {...item.title}>
          <i {...item.icon}>
            <img src={item.icon.children} alt="img" />
          </i>
          {item.title.children}
        </h2>
        <div key="p" {...item.content}>
          {item.content.children}
        </div>
      </QueueAnim>
    );
    return (
      <OverPack key={i.toString()} {...block}>
        {isMobile && textWrapper}
        <QueueAnim
          className="image-wrapper"
          key="image"
          type={isMobile ? 'right' : 'bottom'}
          leaveReverse
          delay={isMobile ? [100, 0] : 0}
          {...item.imgWrapper}
        >
          <div key="image" {...item.img}>
            <img src={item.img.children} alt="img" />
          </div>
          <div key="name" className="name-wrapper">
            <div key="name" {...item.name}>
              {item.name.children}
            </div>
            <div key="post" {...item.post}>
              {item.post.children}
            </div>
          </div>
        </QueueAnim>

        {!isMobile && textWrapper}
      </OverPack>
    );
  };


  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const children = dataSource.block.children.map(this.getBlockChildren);
  

    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>

        <div>
          <Collapse
            bordered={true}
            accordion={false}
            defaultActiveKey={[]}
            expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
          >
            {panelChildren}

            {/* <Panel header="高级程序员 | 九江研发事业部" key="1" style={customPanelStyle}>
              <RczpDetail title="高级程序员" />
            </Panel>
            <Panel header="系统集成售前工程师 | 九江研发事业部" key="2" style={customPanelStyle}>
              <RczpDetail title="系统集成售前工程师" />
            </Panel>
            <Panel header="java研发工程师 | 九江研发事业部" key="3" style={customPanelStyle}>
              <RczpDetail title="java研发工程师" />
            </Panel>
            <Panel header="产品需求分析师 | 九江研发事业部" key="4" style={customPanelStyle}>
              <RczpDetail title="产品需求分析师" />
            </Panel>
            <Panel header="实施工程师 | 九江研发事业部" key="5" style={customPanelStyle}>
              <RczpDetail title="实施工程师" />
            </Panel>
            <Panel header="售前方案工程师 | 九江研发事业部" key="6" style={customPanelStyle}>
              <RczpDetail title="售前方案工程师" />
            </Panel>
            <Panel header="高级系统工程师 | 九江研发事业部" key="7" style={customPanelStyle}>
              <RczpDetail title="高级系统工程师" />
            </Panel> */}
          </Collapse>
          </div>

          {/* <div {...dataSource.block}>{children}</div> */}
        </div>
      </div>
    );
  }
}

export default Content9;
